<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      :modal-append-to-body="false"
      :show-close="false"
      width="100%"
      style="margin-top: 0; height: 100vh"
    >
      <div class="reserBox">
        <div v-for="item in list" :key="item.id" class="item">
          <div class="item_one">
            <div>
              {{ item.scheduledUser }}预定的{{ item.activityRoomName
              }}
              <!-- <span class="status" v-if="item.applyState == '1'">审批中</span>
              <span class="status" v-if="item.applyState == '2'">已通过</span>
              <span class="status" v-if="item.applyState == '3'">已驳回</span>
              <span class="status" v-if="item.applyState == '4'">已撤销</span>
              <span class="status" v-if="item.applyState == '6'"
                >通过后撤销</span
              >
              <span class="status" v-if="item.applyState == '7'">已删除</span> -->
            </div>
            <el-dropdown trigger="click" :hide-on-click="false">
              <span class="el-dropdown-link">
                <i class="el-icon-more"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div @click="edit(item)" style="width: 100%">编辑</div>
                </el-dropdown-item>
                <el-dropdown-item style="color: red">
                  <el-popconfirm
                    title="确定要取消预订吗？"
                    @confirm="cancel(item)"
                  >
                    <div slot="reference">取消预约</div>
                  </el-popconfirm>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="item_two">
            <span>{{ item.scheduledDateFmt }}</span>
            <span style="margin: 0 10px">{{ item.checkDate }}</span>
            <span>{{ item.time }}</span>
          </div>
          <div class="item_three">娱乐室：{{ item.activityAreaName }}</div>
        </div>
      </div>
      <div class="submit">
        <el-button class="submitBtn" @click="query"> 确认 </el-button>
      </div>
    </el-dialog>

    <!-- <dialogSubmit
      :visible.sync="submitDialog"
      :ctimeMenuList="ctimeMenuList"
      :time="ctimeMenuList.time"
      :cText="cText"
      :valueMonth="valueMonth"
      :urlName="urlName"
      :urlId="urlId"
      :userID="userID"
      :userNa="userNa"
      type="2"
    /> -->
  </div>
</template>

<script>
import moment from "moment";
// import dialogSubmit from "./dialogSubmit.vue";
import api from "@/apis/reservation";
// import rw from '@/apis/rw';

export default {
  name: "upload",
  props: ["visible", "valueMonth"],
  components: {
    // dialogSubmit,
  },
  data() {
    return {
      dialogVisible: false,
      list: [],
      submitDialog: false,
      urlName: "",
      urlId: "",
      ctimeMenuList: "",
      userID: "",
      userNa: "",
      cText: "",
    };
  },
  watch: {
    // 监听父组件传入的 visible 属性变化
    visible(v) {
      this.dialogVisible = v;
      if (v) {
        const { name, id } = this.$route.query;
        this.urlName = name;
        this.urlId = id;
        this.getList();
      }
    },
  },
  computed: {
    // cText() {
    //   return moment(this.valueMonth).format("M月DD日");
    // },
  },
  mounted() {},
  methods: {
    //编辑预约
    edit(item) {
      this.ctimeMenuList = item;
      this.cText = moment(item.scheduledDate).format("M月DD日");
      this.urlName = item.activityRoomName;
      this.urlId = item.activityAreaId;
      this.userID = item.joinUser;
      this.userNa = item.joinUserName;
      // :ctimeMenuList="ctimeMenuList"
      // :time="ctimeMenuList.time"
      // :cText="cText"
      // :valueMonth="valueMonth"
      // :urlName="urlName"
      // :urlId="urlId"
      // :userID="userID"
      // :userNa="userNa"
      // type="2"
      // this.submitDialog = true;

      console.log(item, "item");
      this.$router.push({
        path: "/mobReservation/submit",
        query: {
          // url的参数, 类似get请求的传参
          ctimeMenuList: item,
          time: item.time,
          cText: this.cText,
          valueMonth: this.valueMonth,
          urlName: this.urlName,
          urlId: this.urlId,
          userID: item.joinUser,
          userNa: item.joinUserName,
          type: "2",
        },
      });
    },
    // 取消预约
    cancel(item) {
      api.cancelApplyActivityRoom({ id: item.id }).then(() => {
        this.$message({
          type: "success", // success error warning
          message: "取消成功",
          duration: 2000,
        });
        this.getList();
      });
    },
    // 关闭弹窗
    query() {
      this.$emit("update:visible", false);
    },
    // 获取预约列表
    getList() {
      api.queryMyReservation().then((data) => {
        console.log(data, "data");
        const res = data.data;
        res.forEach((item) => {
          item.checkDate = this.checkDate(
            moment(item.scheduledDate).format("YYYY-MM-DD")
          );
          // item.date = moment(item.scheduledDateFmt).format("MM月DD日");
          item.time = this.formatTime(item.scheduledTime);
        });
        this.list = res;
      });
      // this.list.forEach((item) => {
      //   item.checkDate = this.checkDate(moment(item.date).format("YYYY-MM-DD"));
      //   item.date = moment(item.date).format("MM月DD日");
      //   item.time = this.formatTime(item.time);
      // });
    },
    //转换时间格式
    checkDate(time) {
      const inputMoment = moment(time);
      const now = moment();
      const daysDiff = inputMoment.diff(now, "days");
      const weekDayNum = inputMoment.day();
      const weekDaysShort = [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六",
      ];
      const day = weekDaysShort[weekDayNum];
      let textToday;

      if (inputMoment.isSame(now, "day")) {
        textToday = `今天(${day})`;
      } else if (daysDiff == 0) {
        textToday = `明天(${day})`;
      } else if (daysDiff == 1) {
        textToday = `后天(${day})`;
      } else if (daysDiff >= 2) {
        textToday = `(${day})`;
      } else {
        textToday = day;
      }
      return textToday;
    },
    //格式化时间
    formatTime(timeRange) {
      const [start, end] = timeRange.split("-");
      const [startHour, startMinute = "00"] = start.split(":");
      const [endHour, endMinute = "00"] = end.split(":");

      const formattedStart = `${startHour.padStart(
        2,
        "0"
      )}:${startMinute.padStart(2, "0")}`;
      const formattedEnd = `${endHour.padStart(2, "0")}:${endMinute.padStart(
        2,
        "0"
      )}`;

      return `${formattedStart}-${formattedEnd}`;
    },
    // 关闭弹窗
    beforeClose(done) {
      this.$emit("update:visible", false);
      done();
    },
    // 刷新数据
    finished() {
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
  },
};
</script>

<style lang="scss" scoped>
.reserBox {
  height: 90vh;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
}
.item {
  // background: rgb(235, 232, 232);
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 20px;
}
.item:hover {
  background: rgb(235, 232, 232);
}
.item_one {
  // margin-top: -30px;
  font-weight: bold;
  font-size: 24px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-dropdown {
    font-size: 28px;
  }
  .status {
    border: 1px solid #ccc;
    font-size: 20px;
    padding: 5px 10px;
    font-weight: normal;
    color: #ccc;
    margin-left: 10px;
  }
}
.item_two {
  margin: 15px 0;
  font-size: 23px;
}
.item_three {
  margin: 15px 0;
  font-size: 23px;
}
.submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.submitBtn {
  color: #fff;
  background: rgba(50, 106, 251, 1);
  border: 1px solid rgba(50, 106, 251, 1);
  width: 200px !important;
  height: 65px !important;
  border-radius: 100px;
}
::v-deep {
  .el-dialog {
    margin: 0 !important;
    height: 100vh !important;
  }
  .el-dialog__body {
    padding: 20px;
    // height: auto !important;
    // overflow: auto;
    // display: flex;
    // align-items: center;
    // justify-content: center;
  }
  .el-dialog__header {
    height: 0 !important;
    padding: 0 !important;
  }
  // .el-dialog {
  //   height: 60vh;
  // }
}
</style>

<style lang="scss">
.el-dropdown-menu--mini .el-dropdown-menu__item {
  line-height: 80px;
  padding: 0 30px;
}
.el-popconfirm__action {
  margin-top: 20px;
  button:nth-child(1) {
    margin-right: 20px;
  }
}
</style>
